<template>
  <div class="admcfg-container">
    <!-- Page Header -->
    <b-container fluid class="mb-4">
      <b-row>
        <b-col cols="12">
          <h1 class="page-title">
            <i class="fas fa-cog mr-2" />
            {{ $t('menu.management', 'Management') }}
          </h1>
          <p class="page-subtitle">
            {{ $t('admcfg.description', 'Administration panel for managing services and utilities') }}
          </p>
        </b-col>
      </b-row>
    </b-container>

    <!-- Check access permission -->
    <b-container fluid v-if="!hasAdminAccess">
      <b-alert variant="danger" show>
        <i class="fas fa-lock mr-2" />
        {{ $t('error.accessDenied', 'Access denied. This page is only available to administrators.') }}
      </b-alert>
    </b-container>

    <!-- Main content (visible only for admin) -->
    <b-container fluid v-else>
      <!-- Tabs -->
      <b-tabs
        v-model="activeTab"
        class="admcfg-tabs"
        content-class="mt-3"
        nav-class="nav-tabs-custom"
      >
        <!-- Services Tab -->
        <b-tab
          :title="$t('admcfg.services', 'Services')"
          active
        >
          <services-tab />
        </b-tab>

        <!-- Utils Tab -->
        <b-tab
          :title="$t('admcfg.utils', 'Utils')"
        >
          <utils-tab />
        </b-tab>
      </b-tabs>
    </b-container>
  </div>
</template>

<script>
import ServicesTab from './tabs/ServicesTab.vue'
import UtilsTab from './tabs/UtilsTab.vue'

export default {
  name: 'Management',
  components: {
    ServicesTab,
    UtilsTab,
  },
  data() {
    return {
      activeTab: 0,
      redirectTimeout: null
    }
  },
  computed: {
    hasAdminAccess() {
      // Check if user email is the admin email
      const user = this.$store.state.auth.user
      return user && user.email === 'ecdis-link-admin@mkart.fi'
    },
    userEmail() {
      return this.$store.state.auth.user?.email || 'Unknown'
    },
  },
  mounted() {
    // If user doesn't have access, redirect to home after 3 seconds
    if (!this.hasAdminAccess) {
      this.redirectTimeout = setTimeout(() => {
        this.$router.push({ name: 'home' }).catch(() => {})
      }, 3000)
    }
  },
  beforeDestroy() {
    if (this.redirectTimeout) {
      clearTimeout(this.redirectTimeout);
    }
  },
}
</script>

<style scoped>
.admcfg-container {
  padding: 20px 0;
}

.page-title {
  color: #0066cc;
  font-size: 2rem;
  font-weight: 600;
  margin-bottom: 10px;
}

.page-subtitle {
  color: #666;
  font-size: 1rem;
  margin: 0;
}

.admcfg-tabs {
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.nav-tabs-custom {
  border-bottom: 2px solid #e9ecef;
}

.nav-tabs-custom .nav-link {
  color: #666;
  border: none;
  border-bottom: 3px solid transparent;
  padding: 12px 20px;
  margin-right: 10px;
  font-weight: 500;
  transition: all 0.3s ease;
}

.nav-tabs-custom .nav-link:hover {
  color: #0066cc;
  border-bottom-color: #0066cc;
}

.nav-tabs-custom .nav-link.active {
  color: #0066cc;
  border-bottom-color: #0066cc;
  background-color: transparent;
}
</style>
